import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WishlistToggleComponentDef } from '@df/session/wishlist/wishlist-toggle.component.def';
import { ActionComponent } from 'projects/app-default/src/app/ui/api/action.component';
@Component({
    selector: 'lp-wishlist-toggle',
    templateUrl: 'lp-wishlist-toggle.html',
    styleUrls: ['./lp-wishlist-toggle.scss'],
    standalone: true,
    imports: [ActionComponent, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LpWishlistToggleComponent extends WishlistToggleComponentDef {
    @Input()
    inWishlistView?: boolean;
}
